module.exports = __webpack_public_path__ + "public/images/secret-image3.9d2821c90787e4f705d0fac600d4d851.jpeg";